import { Grid } from '@mui/material';
import clsx from 'clsx';

import { useStyles } from './style';
import { LoadingDetailsBlock, LoadingDetailActionsBlock } from '../../../../../../components';

interface SummaryLoadingProps {
	className?: string;
}

const SummaryLoading = (props: SummaryLoadingProps) => {
	const classes = useStyles();

	const { className } = props;

	const gridProps = { item: true, xs: 12, md: 6, lg: 6, xl: 4 };

	return (
		<Grid className={clsx(classes.root, className)} container spacing={3}>
			<Grid {...gridProps}>
				<LoadingDetailsBlock />
			</Grid>
			<Grid {...gridProps}>
				<LoadingDetailsBlock />
			</Grid>
			<Grid {...gridProps}>
				<LoadingDetailsBlock />
			</Grid>
			<Grid {...gridProps}>
				<LoadingDetailActionsBlock />
			</Grid>
		</Grid>
	);
};

export default SummaryLoading;
